import { useEffect } from 'react';
import { api, handleAjaxError } from 'lib/ajax';
import routes from 'lib/routes';
//import useIsMountedRef from 'hooks/useIsMountedRef';
import { captureMessage } from 'lib/sentry';
import mixpanel from 'mixpanel-browser';


function cleanUp() {
    // Remove all saved data from sessionStorage
    sessionStorage.clear();
    
    localStorage.setItem('userAuthState', 'logout');
    
}

export default async function logout() {
    try {
        const res = await api.httpGet(routes.api.logout);
        mixpanel.reset();
        cleanUp();
        return res;
    }
    catch (err) {
        cleanUp();
        window.location.href = routes.login;
        throw err;
    }    
}

logout.clear = () => {
    cleanUp();
};

export function Logout({ toggle }) {
    //const isMoutedRef = useIsMountedRef();
    useEffect(() => {
        if (toggle) {
            (async () => {
                try {
                    await logout(); 
                    window.location.href = routes.login;                   
                }
                catch (err) {
                    handleAjaxError(err, (message, errors) => {
                        captureMessage(`Network error when trying to logout: "${message}" [${JSON.stringify(errors)}]`);
                    });
                    requestAnimationFrame(() => {
                        window.location.href = routes.home;
                    });
                }
            })();
        }       
    }, [toggle]);
    return null;
}